import { groupsSlice } from './slice';

export const { actions, reducer } = groupsSlice;
export { selectors } from './adapter';
export * as thunks from './thunks';
export * from './types';
